<div class="main-container">
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-card appearance="outlined">
      <mat-card-title>Set up holiday greetings for account <b>{{getAccountName()}}</b></mat-card-title>
      <mat-card-content *ngIf="isLoading">
        <mat-progress-spinner style="margin: auto" [diameter]="150" [strokeWidth]="10"
                              mode="indeterminate"></mat-progress-spinner>
      </mat-card-content>
      <mat-card-content *ngIf="!isLoading">
        <!--<app-mat-simple-select [formControl]="accountControl" label="Account" name="account"
                               [selectItems]="availablePbxAccounts"
                               [submitted]="submitted" [disabled]="account != 'new'"></app-mat-simple-select>-->

        <app-mat-simple-select [formControl]="getFormControl('mailboxAccount')" label="Mailbox Account"
                               name="mailboxAccount"
                               infoText="NOTE: For this greeting, the caller can press 0 at anytime to be redirected to the mailbox associated with this account."
                               [selectItems]="availablePbxExtensions"
                               [submitted]="submitted"></app-mat-simple-select>
        <mat-label class="label-text" style="margin: 20px 0px; display: block">Holidays</mat-label>
        <div fxLayout="row" fxLayoutGap="10px" style="margin-bottom: 1em">
          <mat-label fxFlex="30" class="label-text">Start Time</mat-label>
          <mat-label fxFlex="30" class="label-text">End Time</mat-label>
          <mat-label fxFlex="35" class="label-text">Recording</mat-label>
          <mat-label fxFlex="5" class="label-text"></mat-label>
        </div>

        <div fxLayout="column" fxLayoutGap="10px" formArrayName="holidayList">
          <div fxLayout="row" fxLayoutGap="10px" *ngFor="let item of holidayFormArray.controls; let i=index"
               [formGroupName]="i">
            <app-mat-datetime-input fxFlex="30" [formControl]="getFormControl('startDate', item)"
                                    [hideLabel]="true"
                                    [inlineLabel]="true"
                                    [submitted]="submitted"
                                    name="startDate"></app-mat-datetime-input>

            <app-mat-datetime-input fxFlex="30" [formControl]="getFormControl('endDate', item)"
                                    [hideLabel]="true"
                                    [inlineLabel]="true"
                                    [submitted]="submitted"
                                    [customErrors]="{maxDateRange: 'Date range must be less than 365 days', greaterThenStart: 'Must be greater than start date', rangeOverlap: 'Holidays must not overlap other holidays'}"
                                    name="endDate"></app-mat-datetime-input>
            <div fxFlex="35" fxLayout="column" fxLayoutGap="5px">
              <div fxLayout="row" fxLayoutGap="10px">
                <button type="button" mat-stroked-button class="button-48 auto-width"
                        matTooltip="Play Recording - {{item.value.filename}}"
                        *ngIf="item.value.recId || item.value.recCustomId"
                        (click)="onPlayRecording(item.value)" [disabled]="submitted">Play
                  <mat-icon>play_arrow</mat-icon>
                </button>
                <button type="button" mat-stroked-button class="button-48 auto-width" matTooltip="Choose New Recording"
                        (click)="editRecording(item)" [disabled]="submitted">
                  <mat-icon>edit</mat-icon>
                  Edit
                </button>
              </div>
              <!--<mat-hint style="font-size: 75%;" *ngIf="item.value.recId">{{item.value.filename}}</mat-hint>-->
              <mat-error *ngIf="!item.value.recId" style="font-size: 75%;">Recording is required</mat-error>
            </div>
            <div>
              <button mat-icon-button color="warn" type="button" (click)="removeHoliday(i)" [disabled]="submitted">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <button type="button" mat-stroked-button (click)="addNewHoliday()" style="margin-top: 10px" [disabled]="submitted">
          <i class="material-icons">add</i> Add New Holiday
        </button>

      </mat-card-content>
      <mat-card-actions *ngIf="!isLoading">
        <button type="submit" mat-raised-button color="primary" matTooltip="Save changes"
                [promiseBtn]="buttonSubmitPromise"
                *ngIf="hasEditAccess">
          Save
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
  <div class="recordings-control-container">
    <app-audio-control #audioPlayer [src]="currentAudioSource"
                       [downloadSrc]="currentAudioDownloadSource"
                       [showDelete]="false"
                       [showDownload]="false"
                       [autoPlay]="true"
                       title="Holiday Greeting"
                       (errorEmitter)="onAudioError($event)"
    ></app-audio-control>
  </div>
</div>
